import { ProductSearchContext } from '@lib/product-search-context'
import { UIContext } from '@lib/site-context'
import { useContext } from 'react'

interface DropdownButtonProps {
  id: string
  title: string
  className?: string
}

const DropdownButton = ({ id, title, className }: DropdownButtonProps) => {
  const { megaNavigation, toggleMegaNavigation } = useContext(UIContext)
  const { toggleProductSearchDrawer } = useContext(ProductSearchContext)

  const isActive = megaNavigation?.activeId === id

  return (
    <button
      aria-expanded={isActive}
      aria-controls={`meganav-${id}`}
      onClick={() => {
        toggleProductSearchDrawer(false)
        toggleMegaNavigation(!isActive ? true : 'toggle', id)
      }}
      className={className}
    >
      {title}
    </button>
  )
}

export default DropdownButton
